// src/pages/SignUpPage.jsx
import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

function SignUpPage() {
  const navigate = useNavigate();
  const API_BASE =
  process.env.REACT_APP_API_BASE || "http://localhost:5000";






  // 🔐 Redirect if already logged in
  useEffect(() => {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return;

    const user = JSON.parse(raw);
    if (user?.id) {
      navigate("/app", { replace: true });
    }
  } catch {
    localStorage.removeItem("user");
  }
}, [navigate]);


  const [formData, setFormData] = useState({
  username: "",
  password: "",
  studentNumber: "",
  courses: {
    NET: false,
    OS: false,
    AI: false,
    SQPM: false,
  },
});



  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleCourseToggle = (code) => (e) => {
  setFormData((prev) => ({
    ...prev,
    courses: {
      ...prev.courses,
      [code]: e.target.checked,
    },
  }));
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage("");

  const selectedCourses = Object.entries(formData.courses)
  .filter(([_, checked]) => checked)
  .map(([code]) => code);


  const signupData = {
  username: formData.username,
  password: formData.password,
  studentNumber: formData.studentNumber,

  courses: selectedCourses, // ✅ ADD THIS

  // placeholders required by your current backend schema
  firstName: "User",
  lastName: "User",
  email: `${formData.username}@lifeshot.app`,
  role: "user",
};



  try {
    const response = await fetch(`${API_BASE}/signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(signupData),
    });

    const data = await response.json();

    if (!response.ok) {
      setMessage(`❌ ${data.error || data.details || "Signup failed"}`);
      return;
    }

    // ✅ SAFETY: only store what exists
    setMessage("✅ Account created! Please log in.");

setTimeout(() => {
  navigate("/login", { replace: true });
}, 800);

  } catch (err) {
    console.error("Signup error:", err);
    setMessage("❌ Failed to connect to server");
  } finally {
    setLoading(false);
  }
};


  return (
    <Container maxWidth="sm" sx={{ mt: 6, mb: 6 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Create your LifeShot account
      </Typography>

      <form onSubmit={handleSubmit}>
        <Box display="flex" flexDirection="column" gap={2}>
          


          <TextField
            label="Username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />

          <TextField
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <TextField
            label="Ontario Tech Student Number"
            name="studentNumber"
            value={formData.studentNumber}
            onChange={handleChange}
            required
          />

          <Divider sx={{ my: 1 }} />

<Typography variant="subtitle1" fontWeight={700}>
  Courses (Winter 2026)
</Typography>

<FormGroup>
  <FormControlLabel
    control={
      <Checkbox
        checked={formData.courses.NET}
        onChange={handleCourseToggle("NET")}
      />
    }
    label="NET — Computer Networks"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={formData.courses.OS}
        onChange={handleCourseToggle("OS")}
      />
    }
    label="OS — Operating Systems"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={formData.courses.AI}
        onChange={handleCourseToggle("AI")}
      />
    }
    label="AI — Intro to AI"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={formData.courses.SQPM}
        onChange={handleCourseToggle("SQPM")}
      />
    }
    label="SQPM — Software Quality & Project Management"
  />
</FormGroup>


          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{ mt: 1 }}
          >
            {loading ? "Creating account..." : "Sign Up"}
          </Button>
        </Box>
      </form>

      {message && (
        <Typography
          sx={{ mt: 3 }}
          color={message.startsWith("✅") ? "success.main" : "error"}
        >
          {message}
        </Typography>
      )}

      <Typography sx={{ mt: 3 }} variant="body2" color="text.secondary">
        Already have an account?{" "}
        <span
          style={{ color: "#16A34A", cursor: "pointer", fontWeight: 600 }}
          onClick={() => navigate("/login")}
        >
          Log in
        </span>
      </Typography>
    </Container>
  );
}

export default SignUpPage;
